import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import '@hue/design-system/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/app.js';

const root = document.getElementById('root');
if (!root) throw new Error('Elemento raiz não encontrado.');

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000 } } });
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
